var _circle, _g, _path, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbotHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3066 24.6799C31.3865 22.6946 32 20.419 32 18C32 10.268 25.732 4 18 4C10.268 4 4 10.268 4 18C4 25.732 10.268 32 18 32C20.3268 32 22.521 31.4324 24.4518 30.428C28.4093 31.2343 32.9152 31.5507 35.542 29.9917C33.5165 29.2437 31.3171 26.8399 30.3066 24.6799Z",
    fill: "#228B22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3066 24.6799L29.8674 24.441L29.7467 24.663L29.8537 24.8918L30.3066 24.6799ZM24.4518 30.428L24.5516 29.9381L24.3781 29.9027L24.221 29.9844L24.4518 30.428ZM35.542 29.9917L35.7972 30.4217L36.6995 29.8862L35.7152 29.5227L35.542 29.9917ZM31.5 18C31.5 20.3334 30.9084 22.5272 29.8674 24.441L30.7459 24.9188C31.8646 22.8621 32.5 20.5045 32.5 18H31.5ZM18 4.5C25.4558 4.5 31.5 10.5442 31.5 18H32.5C32.5 9.99187 26.0081 3.5 18 3.5V4.5ZM4.5 18C4.5 10.5442 10.5442 4.5 18 4.5V3.5C9.99187 3.5 3.5 9.99187 3.5 18H4.5ZM18 31.5C10.5442 31.5 4.5 25.4558 4.5 18H3.5C3.5 26.0081 9.99187 32.5 18 32.5V31.5ZM24.221 29.9844C22.3599 30.9526 20.2446 31.5 18 31.5V32.5C20.409 32.5 22.6822 31.9121 24.6825 30.8716L24.221 29.9844ZM35.2868 29.5618C34.0845 30.2754 32.4053 30.5822 30.4921 30.5969C28.5891 30.6115 26.51 30.3371 24.5516 29.9381L24.3519 30.918C26.3511 31.3252 28.5038 31.6122 30.4998 31.5968C32.4856 31.5816 34.3727 31.2671 35.7972 30.4217L35.2868 29.5618ZM29.8537 24.8918C30.3851 26.0277 31.2211 27.2133 32.1837 28.2123C33.1422 29.207 34.2597 30.0512 35.3688 30.4608L35.7152 29.5227C34.7989 29.1843 33.8039 28.4525 32.9037 27.5184C32.0076 26.5884 31.2386 25.4922 30.7595 24.4681L29.8537 24.8918Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4305,
    cy: 17.9286,
    r: 1.92857,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0047,
    cy: 17.9286,
    r: 1.92857,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2157,
    cy: 17.9286,
    r: 1.92857,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotHeaderIcon);
export default __webpack_public_path__ + "static/media/chatbot_header_icon.5d5563a0.svg";
export { ForwardRef as ReactComponent };